module.exports = __webpack_public_path__ + "img/umiem.a07aec72.png";